import {
  REQUEST_WINTER_GROUPS,
  RESPONSE_WINTER_GROUPS,
  REQUEST_WINTER_GROUPS_FAILURE,
  SELECT_WINTER_GROUPS,
  REQUEST_ADD_WINTER_UNIT_GROUP,
  RESPONSE_ADD_WINTER_UNIT_GROUP,
  REQUEST_ADD_WINTER_UNIT_GROUP_FAILURE,
  REQUEST_DELETE_WINTER_UNIT_GROUP,
  RESPONSE_DELETE_WINTER_UNIT_GROUP,
  REQUEST_DELETE_WINTER_UNIT_GROUP_FAILURE,
} from "../actions/winterGroupsAction";

import {
  REQUEST_WINTER_UNITS,
  RESPONSE_WINTER_UNITS,
  REQUEST_WINTER_UNITS_FAILURE,
  REQUEST_ADD_WINTER_UNIT,
  RESPONSE_ADD_WINTER_UNIT,
  REQUEST_ADD_WINTER_UNIT_FAILURE,
  REQUEST_DELETE_WINTER_UNIT,
  RESPONSE_DELETE_WINTER_UNIT,
  REQUEST_DELETE_WINTER_UNIT_FAILURE,
} from "../actions/winterUnitsAction";

import { states } from "./queriesStates";

const initialState = {
  winterGroupsDataState: states.NOT_REQUESTED,
  winterUnitsDataState: states.NOT_REQUESTED,
  addWinterUnitDataState: states.NOT_REQUESTED,
  deleteWinterUnitDataState: states.NOT_REQUESTED,
  addWinterUnitGroupDataState: states.NOT_REQUESTED,
  deleteWinterUnitGroupDataState: states.NOT_REQUESTED,
  selectedWinterGroup: null,
  winterGroups: [],
  winterUnits: [],
  errors: null,
};

const winterReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_WINTER_GROUPS:
      return Object.assign({}, state, {
        winterGroupsDataState: states.REQUEST,
        winterGroups: [],
      });
    case RESPONSE_WINTER_GROUPS:
      return Object.assign({}, state, {
        winterGroupsDataState: states.READY,
        winterGroups: action.data.groups,
      });
    case REQUEST_WINTER_GROUPS_FAILURE:
      return Object.assign({}, state, {
        winterGroupsDataState: states.FAILURE,
        errors: action.errors,
      });

    case SELECT_WINTER_GROUPS:
      return Object.assign({}, state, {
        selectedWinterGroup: action.data,
      });

    case REQUEST_WINTER_UNITS:
      return Object.assign({}, state, {
        winterUnitsDataState: states.REQUEST,
        winterUnits: [],
      });
    case RESPONSE_WINTER_UNITS:
      return Object.assign({}, state, {
        winterUnitsDataState: states.READY,
        winterUnits: action.data.winterUnitModels,
      });
    case REQUEST_WINTER_UNITS_FAILURE:
      return Object.assign({}, state, {
        winterUnitsDataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_ADD_WINTER_UNIT:
      return Object.assign({}, state, {
        addWinterUnitDataState: states.REQUEST,
      });
    case RESPONSE_ADD_WINTER_UNIT:
      return Object.assign({}, state, {
        addWinterUnitDataState: states.READY,
        winterUnits: state.winterUnits.concat({ ...action.data, groups: [] }),
      });
    case REQUEST_ADD_WINTER_UNIT_FAILURE:
      return Object.assign({}, state, {
        addWinterUnitDataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_DELETE_WINTER_UNIT:
      return Object.assign({}, state, {
        deleteWinterUnitDataState: states.REQUEST,
      });
    case RESPONSE_DELETE_WINTER_UNIT:
      return Object.assign({}, state, {
        deleteWinterUnitDataState: states.READY,
        winterUnits: state.winterUnits.filter((x) => {
          return x.id !== action.data.id;
        }),
      });
    case REQUEST_DELETE_WINTER_UNIT_FAILURE:
      return Object.assign({}, state, {
        addWideleteWinterUnitDataStatenterUnitDataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_ADD_WINTER_UNIT_GROUP:
      return Object.assign({}, state, {
        addWinterUnitGroupDataState: states.REQUEST,
      });
    case RESPONSE_ADD_WINTER_UNIT_GROUP:
      return Object.assign({}, state, {
        addWinterUnitGroupDataState: states.READY,
        winterUnits: state.winterUnits.map((x) => {
          if (x.id === action.unit.id) {
            x.groups = x.groups.concat(action.group);
          }

          return x;
        }),
      });
    case REQUEST_ADD_WINTER_UNIT_GROUP_FAILURE:
      return Object.assign({}, state, {
        addWinterUnitGroupDataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_DELETE_WINTER_UNIT_GROUP:
      return Object.assign({}, state, {
        deleteWinterUnitGroupDataState: states.REQUEST,
      });
    case RESPONSE_DELETE_WINTER_UNIT_GROUP:
      return Object.assign({}, state, {
        deleteWinterUnitGroupDataState: states.READY,
        winterUnits: state.winterUnits.map((x) => {
          if (x.id === action.unit.id) {
            x.groups = x.groups.filter((f) => {
              return f.id !== action.group.id;
            });
          }

          return x;
        }),
      });
    case REQUEST_DELETE_WINTER_UNIT_GROUP_FAILURE:
      return Object.assign({}, state, {
        deleteWinterUnitGroupDataState: states.FAILURE,
        errors: action.errors,
      });

    default:
      return state;
  }
};

export default winterReducer;
